<template>
  <div class="home">
    <div class="header">
      <router-view name="header" />
    </div>
    <div class="main-container">
      <div class="sidebar">
        <router-view name="sidebar" />
      </div>
      <div class="main">
        <router-view name="main" />
      </div>
      <div class="altsidebar">
        <router-view name="altsidebar" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ui from "@/store/modules/ui";

export default {
  name: "Home",
  components: {},
  created() {
    window.addEventListener("beforeunload", e => {
      if (this.checkHasUnsavedChange()) {
        e.returnValue = "There are unsaved changes";
      }
    });
  },
  methods: {
    checkHasUnsavedChange() {
      return ui.hasUnsavedChange;
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  // act as a container
  height: 100%;
}

.header {
  flex: 0 0 auto;
  // background: hsl(0, 0, 96%);
}

.main-container {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.sidebar {
  width: 10rem;
  flex: 0 1 auto;
}

.altsidebar {
  width: 10rem;
  flex: 0 1 auto;
}

.main {
  flex: 1 0 0;
}
</style>
